import React from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const MultiSelect = (props) => {
    const { label, require, name, value, disable, defaultValue, fpgerror, toolTip, uppercase, optionID, creditOption, DefaultOption, options, toolId } = props
    const HandleChange = (e, name) => {
        if (optionID) {
            props.onChange(e, optionID, name)
        }
        else if (props.item && props.credit) {
            props.onChange(e, props.item._id, props.credit._id, name)
        }
        else if(name ==='personWithDisability'){
            props.onChange(e, props.half, props.cred, name)
        }
        else {
            props.onChange(e)
        }

    }


    return (
        <div className="field_row_inner">
            {label ? <label className={`${require ? 'required' : null} ${uppercase ? 'sd_textuppercase' : ''}`}>{label}</label> : ""}
            <div className="select_field relative">
                <Select options={options} isMulti components={animatedComponents} placeholder={DefaultOption} name={name} onChange={(e) => HandleChange(e, name)} value={value}/>
                {/* <select disabled={disable} name={name} onChange={(e) => HandleChange(e)} value={value}>
                    {DefaultOption ? <option value="" >{DefaultOption}</option> : ''}
                    {options}
                </select> */}
                {fpgerror ? <span className="error" style={{ color: 'red' }} >{fpgerror}</span> : ""}
            </div>
        </div>
    )
}

export default MultiSelect